// @ts-ignore
import type {OutputSelector} from 'reselect';
import type {Competitor} from '../types';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';

type CompetitorsModuleState = {
    competitors: CollectionState<Competitor>;
};

/*
 * Given the entire redux state, pull out just the piece of state for the competitors reducer.
 */
const getCompetitorsState = (state: CompetitorsModuleState) => state.competitors;

/*
 * Get an array of all competitors models
 */
export const getAll: OutputSelector<any, any, Competitor[]> =
    Collections.makeGetModels(getCompetitorsState);

/*
 * Get the `byId` portion of the competitors state
 */
export const getById = (state: CompetitorsModuleState) => {
    const competitorsState = getCompetitorsState(state);

    return Collections.getById(competitorsState);
};
